module.exports = __webpack_public_path__ + "zvetseni-prsou_16_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_16_after.jpg
// module id = 1305
// module chunks = 0